/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { IntegrationSection } from './IntegrationSection/IntegrationSection'
import useUser from '../Shared/UserProvider/useUser'
import { isProviderAPos } from '../../services/Provider/Provider.service'
import { BusinessPerformanceSection } from './BusinessPerformanceSection/BusinessPerformanceSection'
import { OperationalPerformanceSection } from './OperationalPerformanceSection/OperationalPerformanceSection'
import { OfferPerformanceSection } from './OfferPerformanceSection/OfferPerformanceSection'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import useBreadcrumb from '../NavBar/useBreadcrumb'
import { FeatureInfo } from '../Shared/FeatureInfo/FeatureInfo'
import { useNavigate } from 'react-router-dom-v5-compat'
import { Button, Icon } from 'semantic-ui-react'
import useTracking from '../../services/Tracking/useTracking'
import { useDeviceMediaQuery } from '../Shared/UseDeviceMediaQuery/useDeviceMediaQuery'
import { useFeatureInfoVisibility } from '../Home/Margin/hooks/useFeatureInfoVisibility'
import { useLocalStorageItem } from '../../helpers/useLocalStorageItem'


const Dashboard = () => {
    const [t] = useTranslation()
    const {setPaths} = useBreadcrumb()
    const {user} = useUser()
    const { isMobile } = useDeviceMediaQuery()
    const {track} = useTracking('dashboard')
    const [isFeatureInfoVisible, setFeatureInfoVisible] = useFeatureInfoVisibility({ key: 'dashboard' })
    const navigate = useNavigate()
    const [, setDashboardSoftRolloutTarget] = useLocalStorageItem('dashboard_soft_rollout_target')

    useEffect(() => {
        setPaths([{
            text: t('breadcrumb.home'),
            link: false,
            path: '/',
        }])
    }, [setPaths, t])

    return (
      <>
          <FeatureInfo featureName="dashboard"
                       isVisible={isFeatureInfoVisible}
                       onDismiss={() => setFeatureInfoVisible(false)}
                       onOpen={() => setFeatureInfoVisible(true)}
                       css={css`
                           &.ui.message {
                               margin-bottom: 1rem;
                           }

                           &.blue.info.circle.icon {
                               margin-top: 1rem;
                               width: 16px;
                               height: 16px;
                               vertical-align: text-top;
                           }

                           .content > a {
                               text-align: right;
                           }
                       `}>
              <FeatureInfo.Text><strong>{t('dashboard.feature_info.title')}</strong></FeatureInfo.Text>
              <FeatureInfo.Text>{t('dashboard.feature_info.message')}</FeatureInfo.Text>
              <div css={css`
                  display: flex;
                  flex-direction: ${isMobile ? 'column' : 'row'};
                  justify-content: flex-end;
                  gap: 0.5rem;
              `}>
                  <Button
                    basic
                    color="blue"
                    size='small'
                    onClick={() => {
                        setDashboardSoftRolloutTarget('analytics')
                        track('click_back_to_analytics')
                        navigate('/analytics')
                    }}
                  >
                      {t('dashboard.feature_info.stay_on_previous_dashboard')}
                  </Button>
                  <Button
                    color="blue"
                    onClick={() => {
                        track('click_stay_on_new_dashboard')
                        setFeatureInfoVisible(false)
                    }}
                  >
                      {t('dashboard.feature_info.discover_new_dashboard')}
                      <Icon name='arrow right' />
                  </Button>
              </div>
          </FeatureInfo>

          {isProviderAPos(user.provider) && <IntegrationSection/>}

          <BusinessPerformanceSection/>

          <OperationalPerformanceSection/>

          {!user.isLoggedInOwnScope && <OfferPerformanceSection/>}
      </>
    )
}

export { Dashboard }
